'use client';

import { Text } from '@actr/ui/src/components/_atoms/text';
import { Modal } from '@actr/ui/src/components/_modals/modal';
import { observer } from 'mobx-react-lite';
import React from 'react';

import * as Styled from '../style.css';

export type ErrorModalProps = {
    isShowModal: boolean;
    onClose: () => void;
    isMobile: boolean;
}

const ErrorModal: React.FC<ErrorModalProps> = ({ isShowModal, onClose, isMobile }) => (
  <Modal
    className={Styled.Modal()}
    Title="Отзыв не отправлен"
    isPopup={!isMobile}
    open={isShowModal}
    disableFooterCloseButton={true}
    onClose={onClose}
    onClickFooterButtonOk={onClose}>
    <Text font="paragraph.m">
      Не получилось отправить отзыв. Попробуйте повторить позже еще раз.
    </Text>
  </Modal>
);

export default observer(ErrorModal);
